module.exports = __webpack_public_path__ + "SCTProfessional/static/dist/img/geo_big.ad394b6d.png";